import {BaseFilter} from './base.filter';

export class AccountFilter extends BaseFilter {

}
